export const brandingConfig = {
  appTitle: "AirSmart Partner Portal",
  appDescription: "AirSmart integrator training, onboarding, and certification platform.",
  logos: {
    horizontalBlack: `${process.env.PUBLIC_URL}/Airsmart-Logo-Horizontal-Black.svg`,
    horizontalWhite: `${process.env.PUBLIC_URL}/Airsmart-Logo-Horizontal-White%201.svg`,
  },
  assets: {
    emailBackground: `${process.env.PUBLIC_URL}/assets/image/footer.webp`,
    signinBackground: `${process.env.PUBLIC_URL}/assets/image/signin.webp`,
  },
};

export function getAirsmartLogo(mode = "light") {
  return mode === "dark"
    ? brandingConfig.logos.horizontalWhite
    : brandingConfig.logos.horizontalBlack;
}
